import { http } from "@/http/axios.js";

// 模板列表
export function getComboTemplatePage(params) {
  return http({
    url: "/admin/store/combo/tpl/page",
    method: "get",
    params,
  });
}

// 模板详情
export function getComboTemplateDetail(params) {
  return http({
    url: "/admin/store/combo/tpl/detail",
    method: "get",
    params,
  });
}

// 新增模板
export function addComboTemplate(data) {
  return http({
    url: "/admin/store/combo/tpl/add",
    method: "post",
    data,
  });
}

// 编辑模板名称
export function editComboTemplate(data) {
  return http({
    url: "/admin/store/combo/tpl/edit",
    method: "post",
    data,
  });
}

// 设置默认模板
export function editComboTemplateDefault(data) {
  return http({
    url: "/admin/store/combo/tpl/default/edit",
    method: "post",
    data,
  });
}

// 模板绑定方案
export function bindComboTemplate(data) {
  return http({
    url: "/admin/store/combo/tpl/bind",
    method: "post",
    data,
  });
}
